import React, { FC } from 'react';
import { round } from 'lodash';
import { useTranslation } from 'react-i18next';

import EventProgress from 'pages/events/EventProgress';

import { useEvent } from 'components/context/EventContext';

import useStyles from './style';

const ProgessInfo: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { event } = useEvent();

  const sectionsWithSongsProgress = (event?.sectionsWithSongsProgress ?? 0) * 100;
  const questionsProgress = (event?.progress ?? 0) * 100;

  return (
    <div className={classes.progressInfo}>
      <EventProgress
        label={t('songSectionsProgress', {
          currentCount: event?.sectionsWithSongs,
          allCount: event?.sectionsWithSongsTotal,
        })}
        info={`${round(sectionsWithSongsProgress)}%`}
        progress={sectionsWithSongsProgress}
      />
      <EventProgress
        label={t('questionsProgress', {
          currentCount: event?.answeredQuestionsCount,
          allCount: event?.questionsCount,
        })}
        info={`${round(questionsProgress)}%`}
        progress={questionsProgress}
      />
    </div>
  );
};

export default ProgessInfo;
